const userTypes = {
    0:"直销客户",
    1:"工业分销商",
    2:"建筑连接器分销商-零售渠道",
    3:"建筑连接器分销商-工程渠道",
    4:"筑连接器分销商-电商渠道",
    5:"工业代理商",
    6:"系统集成商",
    7:"WAGO用户",
    8:"建筑直销渠道",
    9:"建筑连接器分销商-家装渠道",
    10:"工业贸易商"
}

export default userTypes;


/*
            //工业分销商
            Type1 = 1,
            //建筑连接器分销商-零售渠道
            Type2 = 2,
            //建筑连接器分销商-工程渠道
            Type3 = 3,
            //建筑连接器分销商-电商渠道
            Type4 = 4,
            //工业代理商
            Type5 = 5,
            //建筑直销渠道
            Type8 = 8,
            //系统集成商
            Type6 = 6,
            //WAGO用户
            Type7 = 7,
            //建筑连接器分销商-家装渠道
            Type9 = 9,
            //工业贸易商
            Type10 =10

*/


// WEBPACK FOOTER //
// ./src/models/userTypes.js